import { IAuthQuery } from 'app/components/pages/Auth';
import { GetHistory } from 'app/components/router/History';
import { QueryParameter } from 'app/constants/QueryParameter';
import { LoginRoute, SignupRoute } from 'app/constants/Routes';
import { History } from 'app/services/history';
import { LoginIntent } from 'app/services/oauth/constants';
import { stringify } from 'query-string';
import React, { Component } from 'react';
import PageMeta from 'app/components/common/PageMeta';

interface IProps {
  history: History;
  intent: LoginIntent;
  automaticLogin?: boolean;
  iframe?: boolean;
  dmmLoginEnv?: string;
  showAllAuthMethods?: boolean;
  returnAfterAuth?: boolean;
}

class RedirectToAuthUnconnected extends Component<IProps> {
  public componentWillMount() {
    const {
      history, automaticLogin, iframe, intent, dmmLoginEnv, showAllAuthMethods, returnAfterAuth = true,
    } = this.props;

    const query: IAuthQuery = {};
    if (returnAfterAuth) {
      query.redirectTo = history.createHref(history.location);
    }
    if (automaticLogin) {
      query.automatic = true.toString();
    }
    if (iframe) {
      query.iframe = true.toString();
    }
    if (dmmLoginEnv) {
      query.dmm_env = dmmLoginEnv;
    }
    if (showAllAuthMethods) {
      query[QueryParameter.ShowAuth] = true.toString();
    }
    const route = intent === LoginIntent.Register ? SignupRoute : LoginRoute;
    const pathname = route.getPathname();

    history.replace({
      pathname,
      search:   stringify(query),
    });
  }

  public render() {
    return <PageMeta noIndex />;
  }
}

const RedirectToAuth = (props: Omit<IProps, 'history'>) => (
  <GetHistory>{(history: History) =>
    <RedirectToAuthUnconnected {...props} history={history} />
  }</GetHistory>
);

export default RedirectToAuth;
